// extracted by mini-css-extract-plugin
export default {"deliveryContainer":"deliveryContainer_deliveryContainer__s6vcg"};